import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { isEmpty, map, keys } from "lodash";

import { h2 } from "~/styles/typographyStyles";

import { isBrowser, scrollToElement } from "~/utilities/helpers";

const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.palette.mediumGray};
    padding: 30px;
`;

const Title = styled.h2`
    ${h2}
    color: ${({ theme }) => theme.palette.red};
`;

const List = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
`;

const ErrorButton = styled.button`
    color: ${({ theme }) => theme.palette.red};
    text-align: left;
    font-weight: bold;
    &:focus {
        outline: solid;
    }
`;

const scrollToInput = (input) => {
    if (isBrowser && input) {
        input.focus();
        scrollToElement(input, 120);
    }
};

const ErrorSummary = ({ errors }) => {
    const firstButtonRef = useRef(null);

    useEffect(() => {
        if (!isEmpty(errors) && firstButtonRef.current) {
            firstButtonRef.current.focus();
            scrollToElement(firstButtonRef.current, 175);
        }
    }, [errors, firstButtonRef]);

    return (
        !isEmpty(errors) && (
            <Wrapper aria-labelledby="error-summary" role="alert">
                <Title id="error-summary">Error Summary</Title>
                <List>
                    {map(keys(errors), (inputName, i) => {
                        const { message, ref, label } = errors[inputName];
                        return (
                            <li key={`${inputName}`}>
                                {i === 0 ? (
                                    <ErrorButton
                                        type="button"
                                        tabIndex="0"
                                        onClick={() => scrollToInput(ref)}
                                        ref={firstButtonRef}
                                    >
                                        {`${
                                            label ? `${label}: ` : ""
                                        }${message}`}
                                    </ErrorButton>
                                ) : (
                                    <ErrorButton
                                        type="button"
                                        tabIndex="0"
                                        onClick={() => scrollToInput(ref)}
                                    >
                                        {`${
                                            label ? `${label}: ` : ""
                                        }${message}`}
                                    </ErrorButton>
                                )}
                            </li>
                        );
                    })}
                </List>
            </Wrapper>
        )
    );
};

ErrorSummary.propTypes = {
    errors: PropTypes.shape({}).isRequired,
};

export default ErrorSummary;
